import React from 'react';
import ProductWizardPage from '../../modules/ProductWizardPage';
import PackageWidget from '../../modules/PackageWidget';
import StudentWaiversLog from '../../modules/student/WaiversLog';
import Settings from '../../modules/settings';
import ParentDashboard from '../../modules/parent/Dashboard';
const Products = React.lazy(() => import('../../modules/student/Products'));

const ProductListing = React.lazy(() =>
  import('../../modules/student/Products/ProductListing'),
);
const ProgramDetail = React.lazy(() =>
  import('../../modules/student/Programs/ProgramDetail'),
);
const PackageDetail = React.lazy(() =>
  import('../../modules/student/Packages/PackageDetail'),
);
const ProductDetail = React.lazy(() =>
  import('../../modules/student/Products/ProductDetail'),
);
const OrdersHistory = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Orders'),
);
const ThridCalendar = React.lazy(() =>
  import('../../modules/thirdParty/calendar'),
);
const Cart = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Carts'),
);
const Checkout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout'),
);
const CardDetails = React.lazy(() =>
  import('../../modules/admin/CreditSystem/ManageCards'),
);
const CreditWallet = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditWallets'),
);
const CreditHistory = React.lazy(() =>
  import('../../modules/admin/CreditSystem/CreditsHistory'),
);
const UserReports = React.lazy(() =>
  import('../../modules/admin/ReportManagement/UserReports'),
);
const StudentWaiver = React.lazy(() => import('../../modules/student/Waivers'));
const OrderConfirmation = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation'),
);
const TransactionHistory = React.lazy(() =>
  import('../../modules/student/TransactionHistory'),
);
const SettingsPage = React.lazy(() =>
  import('../../modules/student/SettingsPage'),
);
const EventSchedules = React.lazy(() =>
  import('../../modules/student/EventSchedules'),
);
const ManageDomains = React.lazy(() =>
  import('../../../../../libs/MobileComponents/ManageDomainsMob'),
);
const PlayerReports = React.lazy(() =>
  import('../../modules/student/PlayerReports'),
);
const AccountPage = React.lazy(() =>
  import('../../modules/student/AccountInfo'),
);
const LockerPage = React.lazy(() =>
  import('../../../../../libs/modules/src/lib/account/MyProfile/LockerPage'),
);
const AutoLinks = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks'),
);
const AddToCart = React.lazy(() =>
  import('../../modules/admin/Packages/PackageLinks/AddToCart'),
);
const AddToCartProduct = React.lazy(() =>
  import('../../modules/admin/Products/ProductLinks/AddToCartProduct'),
);

const StripeForm = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Confirmation/stripe'),
);
const FailedPayment = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/FailedTranscation'),
);
const Error403 = React.lazy(() => import('../../modules/errorPages/Error403'));
const TilledCheckout = React.lazy(() =>
  import('../../modules/dashboards/ecommerce/Checkout-tilled'),
);
const ProfileData = React.lazy(() => import('../../modules/admin/ProfileData'));
const UnSubscribePage = React.lazy(() =>
  import('../../modules/account/MyProfile/UnSubscribe'),
);
const SettingsTabMob = React.lazy(() =>
  import('../../../../../libs/MobileComponents/SettingsTabMob'),
);
const TransactionHistoryMob = React.lazy(() =>
  import('../../../../../libs/MobileComponents/TransactionHistoryMob'),
);
const MissedPaymentCard = React.lazy(() =>
  import('../../modules/student/MissedPaymentCard'),
);
const studentPagesConfigs = (checkMissedPayment, userRole, isMobile) => {
  let studentRoute = [
    {
      path: '/student/profile-data',
      element: <ProfileData />,
    },
    {
      path: '/student/product-listing',
      element: <ProductListing />,
    },
    {
      path: '/student/products',
      element: <Products />,
    },
    {
      path: '/product-details/:productId',
      element: <ProductDetail />,
    },
    {
      path: '/student/program-details/:programId',
      element: <ProgramDetail />,
    },
    {
      path: '/package-details/:packageId',
      element: <PackageDetail />,
    },
    {
      path: '/student/orders-history/',
      element: <OrdersHistory />,
    },
    {
      path: '/student/error-pages/error-403',
      element: <Error403 />,
    },

    {
      path: '/student/waiver',
      element: <StudentWaiver />,
    },
    {
      path: '/student/basic-calendar',
      element: <ThridCalendar />,
    },
    {
      path: '/cart',
      element: <Cart />,
    },
    {
      path: '/checkout',
      element: <Checkout />,
    },
    {
      path: '/student/card-details',
      element: <CardDetails />,
    },
    {
      path: '/student/credit-wallets',
      element: <CreditWallet />,
    },
    {
      path: '/student/credit-history',
      element: <CreditHistory />,
    },
    {
      path: '/student/user-reports',
      element: <UserReports />,
    },
    {
      path: '/order/confirmation/:transId',
      element: <OrderConfirmation />,
    },
    {
      path: '/stripe',
      element: <StripeForm />,
    },
    {
      path: '/order/failed/:transId',
      element: <FailedPayment />,
    },
    {
      path: '/student/my-account',
      element: <AccountPage />,
    },
    {
      path: '/transaction-history',
      element: <TransactionHistory />,
    },
    {
      path: '/student/settings',
      element: <SettingsPage />,
    },
    {
      path: '/student/events',
      element: <EventSchedules />,
    },
    {
      path: '/student/player-reports',
      element: <PlayerReports />,
    },
    {
      path: '/my-profile',
      element: <LockerPage />,
    },
    {
      path: '/widgets/products/:productSlug',
      element: <ProductWizardPage />,
    },
    {
      path: '/widgets/packages/:packageSlug',
      element: <PackageWidget />,
    },
    {
      path: '/purchasePackage/:purchaseId/:packageId',
      element: <AutoLinks />,
    },
    {
      path: '/purchasePackage/addtocart/:purchaseId/:packageId',
      element: <AddToCart />,
    },
    {
      path: '/product/addtocart/:purchaseId/:productId',
      element: <AddToCartProduct />,
    },
    {
      path: '/checkout-tilled',
      element: <TilledCheckout />,
    },
    {
      path: '/student/waivers-log',
      element: <StudentWaiversLog />,
    },
    {
      path: '/user/unsubscribe',
      element: <UnSubscribePage />,
    },
    {
      path: '/student/domains',
      element: <ManageDomains />,
    },
    {
      path: '/student/settingsTab',
      element: <SettingsTabMob />,
    },
    {
      path: '/transactionHistoryMob',
      element: <TransactionHistoryMob />,
    },
    {
      path: '/settings',
      element: <Settings />,
    },
    {
      path: '/dashboard',
      element: <ParentDashboard missedPayments={checkMissedPayment} />,
    },
  ];

  if (checkMissedPayment && !isMobile) {
    studentRoute = [
      {
        path: '/dashboard',
        element: <ParentDashboard restrictDashboard={checkMissedPayment} />,
      },
    ];
  } else if (checkMissedPayment && isMobile) {
    studentRoute = [
      {
        path:   `${userRole}/events`,
        element: <MissedPaymentCard />,
      },
    ];
  }
  return studentRoute;
};
export default studentPagesConfigs;
